import React, { useState } from "react";
import { Row, Col, Card, Dropdown } from "react-bootstrap";
import { FiCalendar, FiChevronDown } from "react-icons/fi";
import CandidatesHeader from "../../components/administration/Candidates/CandidatesHeader";

const data = [
  {
    id: "Cand-001",
    name: "Harold Gaynor",
    role: "Accountant",
    date: "12 Sep 2024",
    status: "New",
    img: "/assets/img/users/user-01-1.jpg",
  },
  {
    id: "Cand-002",
    name: "Sandra Ornellas",
    role: "Accountant",
    date: "12 Sep 2024",
    status: "Scheduled",
    img: "/assets/img/users/user-34.jpg",
  },
  {
    id: "Cand-003",
    name: "John Harris",
    role: "Technician",
    date: "12 Sep 2024",
    status: "Interviewed",
    img: "/assets/img/users/user-09.jpg",
  },
  {
    id: "Cand-004",
    name: "Carole Langan",
    role: "Web Developer",
    date: "12 Sep 2024",
    status: "Offered",
    img: "/assets/img/users/user-26.jpg",
  },
  {
    id: "Cand-005",
    name: "Charles Marks",
    role: "SEO",
    date: "12 Sep 2024",
    status: "Hired",
    img: "/assets/img/users/user-39.jpg",
  },
  {
    id: "Cand-006",
    name: "Kerry Drake",
    role: "Designer",
    date: "12 Sep 2024",
    status: "Rejected",
    img: "/assets/img/users/user-24.jpg",
  },
  {
    id: "Cand-007",
    name: "David Carmona",
    role: "Account Manager",
    date: "12 Sep 2024",
    status: "Hired",
    img: "/assets/img/users/user-33-1.jpg",
  },
  {
    id: "Cand-008",
    name: "Margaret Soto",
    role: "SEO Analyst",
    date: "12 Sep 2024",
    status: "Scheduled",
    img: "/assets/img/users/user-10.jpg",
  },
];

const getStatusClass = (status) => {
  switch (status) {
    case "New":
      return "status-purple";
    case "Scheduled":
      return "status-pink";
    case "Interviewed":
      return "status-blue";
    case "Offered":
      return "status-orange";
    case "Hired":
      return "status-green";
    case "Rejected":
      return "status-red";
    default:
      return "";
  }
};

   const options = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range",
  ];

const CandidatesGrid = () => {
      const [selected, setSelected] = useState("03/27/2026 - 04/02/2026");
 const [open, setOpen] = useState(false);
const [sort, setSort] = useState("Last 7 Days");
  const handleSelect = (item) => {
    setSelected(item);
    setOpen(false);
  };

  return (
    <div className="container-fluid p-3">
<CandidatesHeader/> 
      {/* HEADER */}
      <div className="card mb-3">
        <div className="card-body d-flex justify-content-between flex-wrap">

          <h5>Candidates Grid</h5>

          <div className="d-flex gap-2 flex-wrap">

            {/* DATE */}
       <div className="date-dropdown-wrapper">

      {/* INPUT BOX */}
      <div
        className="input-box"
        onClick={() => setOpen(!open)}
      >
        <input value={selected} readOnly />
        <FiChevronDown />
      </div>

      {/* DROPDOWN */}
      {open && (
        <div className="date-dropdown-menu">
          {options.map((item, i) => (
            <div
              key={i}
              className={`dropdown-item-custom ${
                item === selected ? "active" : ""
              }`}
              onClick={() => handleSelect(item)}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>


            {/* ROLE */}
            <Dropdown>
              <Dropdown.Toggle className="btn-white text-dark">Role</Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Accountant</Dropdown.Item>
                <Dropdown.Item>Developer</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* STATUS */}
            <Dropdown>
              <Dropdown.Toggle className="btn-white text-dark">
                Select Status
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Scheduled</Dropdown.Item>
                <Dropdown.Item>Hired</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* SORT */}
          <Dropdown className="custom-sort-dropdown">
  <Dropdown.Toggle className="btn-white sort-toggle text-dark">
    Sort By : Last 7 Days <span className="ms-1">▾</span>
  </Dropdown.Toggle>

  <Dropdown.Menu className="sort-menu">
    <Dropdown.Item>Recently Added</Dropdown.Item>
    <Dropdown.Item>Ascending</Dropdown.Item>
    <Dropdown.Item>Descending</Dropdown.Item>
    <Dropdown.Item>Last Month</Dropdown.Item>
    <Dropdown.Item active>Last 7 Days</Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>

          </div>
        </div>
      </div>

      {/* GRID */}
      <Row>
        {data.map((item, i) => (
          <Col xl={3} md={6} key={i} className="mb-4">
            <Card className="candidate-card">

              <Card.Body>

                {/* TOP */}
                <div className="d-flex align-items-center mb-3">
                  <img src={item.img} className="grid-avatar" />
                  <div className="ms-2">
                    <h6 className="mb-0">
                      {item.name}
                      <span className="cand-id">{item.id}</span>
                    </h6>
                    <small>[email protected]</small>
                  </div>
                </div>

                {/* DETAILS BOX */}
                <div className="detail-box">
                  <p>
                    <span>Applied Role</span>
                    <strong>{item.role}</strong>
                  </p>
                  <p>
                    <span>Applied Date</span>
                    <strong>{item.date}</strong>
                  </p>
                  <p>
                    <span>Status</span>
                    <span className={`status-badge ${getStatusClass(item.status)}`}>
                      ● {item.status}
                    </span>
                  </p>
                </div>

              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* CSS */}
      <style>{`
        .candidate-card {
          border-radius: 10px;
        }

        .grid-avatar {
          width: 50px;
          height: 50px;
          border-radius: 8px;
        }

        .cand-id {
          font-size: 12px;
          background: #ffe5d6;
          color: #ff6b1a;
          margin-left: 8px;
          padding: 2px 6px;
          border-radius: 6px;
        }

        .detail-box {
          background: #f5f6f8;
          padding: 10px;
          border-radius: 6px;
        }

        .detail-box p {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          margin-bottom: 8px;
        }

        .status-badge {
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 12px;
        }

        .status-purple { background:#ede0ff; color:purple; }
        .status-pink { background:#ffe4ec; color:hotpink; }
        .status-blue { background:#e6f0ff; color:#1677ff; }
        .status-orange { background:#fff3e0; color:orange; }
        .status-green { background:#e6fffa; color:green; }
        .status-red { background:#ffe5e5; color:red; }

        .date-box {
          display:flex;
          align-items:center;
          border:1px solid #ddd;
          padding:6px 10px;
          border-radius:6px;
          gap:6px;
        }

        .date-box input {
          border:none;
          outline:none;
          font-size:14px;
        }

        .btn-white {
          background:#fff !important;
          border:1px solid #ddd !important;
        }


        
// dates
/* WRAPPER */
.date-dropdown-wrapper {
  position: relative;
  width: auto;
}

/* INPUT BOX */
.input-box {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  cursor: pointer;
}

.input-box input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
  cursor: pointer;
}

/* DROPDOWN */
.date-dropdown-menu {
  position: absolute;
  top: 45px;
  width: 15%;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  z-index: 999;
  overflow: hidden;
}

/* ITEM */
.dropdown-item-custom {
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
}

/* HOVER */
.dropdown-item-custom:hover {
  background: #ef8019;
}

/* ACTIVE (ORANGE LIKE IMAGE) */
.dropdown-item-custom.active {
  background: #ff6b1a;
  color: #fff;
}

/* SMALL ARROW (OPTIONAL) */
.date-dropdown-menu::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;
  width: 10px;
  height: 10px;
  background: white;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  transform: rotate(45deg);
}

// sort//
/* TOGGLE BUTTON */
.sort-toggle {
  background: #fff !important;
  border: 1px solid #ddd !important;
  border-radius: 8px !important;
  padding: 8px 14px;
  font-size: 14px;
  color: #333;
}

/* DROPDOWN MENU */
.sort-menu {
  border-radius: 10px !important;
  padding: 10px 0;
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border: 1px solid #eee;
}

/* ITEMS */
.sort-menu .dropdown-item {
  padding: 10px 16px;
  font-size: 14px;
  color: #333;
}

/* HOVER */
.sort-menu .dropdown-item:hover {
  background: #f5f5f5;
}

/* ACTIVE (ORANGE LIKE IMAGE) */
.sort-menu .dropdown-item.active {
  background: #ff6b1a !important;
  color: #fff !important;
  border-radius: 6px;
  margin: 0 6px;
}

        @media(max-width:768px){
          .card-body{
            flex-direction:column;
            gap:10px;
          }
        }
      `}</style>

    </div>
  );
};

export default CandidatesGrid;